export default "https://legacy.eskolare-development.com/images/page-not-found.png";